import React from "react"

import RequestControl from "../../components/LaborAccessRequest/RequestControl/RequestControl"

function RequestControlPage() {
  return <RequestControl />
}

export default RequestControlPage
